import { render, staticRenderFns } from "./ChangeSectionModal.vue?vue&type=template&id=2fa265e0"
import script from "./ChangeSectionModal.vue?vue&type=script&lang=js"
export * from "./ChangeSectionModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeSectionModal.vue?vue&type=style&index=0&id=2fa265e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports